var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.401,
    height: 31.084,
    viewBox: "0 0 30.401 31.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.734,16.849a1.129,1.129,0,0,1-1.12-1.011,11.845,11.845,0,0,0-5.041-8.464,1.129,1.129,0,0,1,1.291-1.851A14.181,14.181,0,0,1,23.87,15.6a1.135,1.135,0,0,1-1.011,1.245Z",
    transform: "translate(5.473 -0.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.142,16.905H4.033a1.135,1.135,0,0,1-1.011-1.245,14.132,14.132,0,0,1,5.912-10.1A1.127,1.127,0,0,1,10.241,7.4a11.875,11.875,0,0,0-4.963,8.479A1.145,1.145,0,0,1,4.142,16.905Z",
    transform: "translate(-1.792 -0.149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.669,21.907a14.014,14.014,0,0,1-6.114,1.385,13.885,13.885,0,0,1-6.363-1.509,1.112,1.112,0,0,1-.5-1.509A1.131,1.131,0,0,1,9.2,19.76,11.618,11.618,0,0,0,12.283,20.8a11.889,11.889,0,0,0,4.325.047,11.749,11.749,0,0,0,3.065-.98,1.134,1.134,0,0,1,1,2.038Z",
    transform: "translate(0.739 7.793)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.617,2.01A4.387,4.387,0,1,0,18,6.4,4.392,4.392,0,0,0,13.617,2.01Z",
    transform: "translate(1.661 -2.01)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.617,13.87A4.387,4.387,0,1,0,11,18.257,4.392,4.392,0,0,0,6.617,13.87Z",
    transform: "translate(-2.23 4.582)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.517,13.87A4.387,4.387,0,1,0,24.9,18.257,4.392,4.392,0,0,0,20.517,13.87Z",
    transform: "translate(5.497 4.582)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.d408ad89.svg";
export { ForwardRef as ReactComponent };